import { configureStore } from "@reduxjs/toolkit";
import userDetailsSlice from "./slice/userDetailsSlice";
import loaderReducer from "./slice/loaderSlice";
import storelistReducer from "./slice/storeListSlice";
import cmspageReducer from "./slice/cmsPageSlice";
import productSearchReducer from "./slice/productsearchSlice";
import cartdetailsReducer from "./slice/cartDetailsSlice";
import SearchtextReducer from "./slice/searchText";
import balanceReducer from "./slice/balanceSlice";
import otherregionstorelistSlice from "./slice/interregionstoreListSlice";
import companySchemesSlice from "./slice/companySchemesSlice";

export const store = configureStore({
  reducer: {
    userDetails: userDetailsSlice,
    loader: loaderReducer,
    storeList: storelistReducer,
    cmspage: cmspageReducer,
    productSearch: productSearchReducer,
    cartDetails: cartdetailsReducer,
    searchText: SearchtextReducer,
    wallet: balanceReducer,
    otherregionstoreList: otherregionstorelistSlice,
    companySchemes: companySchemesSlice,
  },
});

export default store;
